import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import * as services from "../services"
import { REQUESTS_WITHDRAWAL_SLICE_NAME } from "./requestsWithdrawal.constants"

export const getRequestsWithdrawal = createAsyncThunk(
  `${REQUESTS_WITHDRAWAL_SLICE_NAME}/get_requests_withdrawal`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsWithdrawal(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const deleteRequestsWithdrawal = createAsyncThunk(
  `${REQUESTS_WITHDRAWAL_SLICE_NAME}/delete_withdrawal`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.deleteWithdrawal(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return { message: response.data?.message?.detail || response.data?.message }
  }
)

export const getPayoutMethod = createAsyncThunk(
  `${REQUESTS_WITHDRAWAL_SLICE_NAME}/get_payout_method`,
  async (withdrawalId, { dispatch, rejectWithValue }) => {
    const response = await services.getPayoutMethod(withdrawalId)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const setStatus = createAsyncThunk(
  `${REQUESTS_WITHDRAWAL_SLICE_NAME}/set_status`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.setStatus(params)
    if (response.ok && response.data) {
      return response.data
    }
    if (response.ok && (response.status === 201 || response.status === 204)) {
      return params
    }
    await handleApiError(dispatch, response)
    return rejectWithValue(response.data)
  }
)
